import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MainTopNavigationComponentGeneric } from "./main-top-navigation";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        BsDropdownModule.forRoot()
    ],
    declarations: [MainTopNavigationComponentGeneric],
    exports: [MainTopNavigationComponentGeneric]
})
export class MainTopNavigationModuleGeneric {}
